module.exports = __webpack_public_path__ + "assets/retina_MirrorSegDetailed.c04d8b3dd762a708decd2699c930603b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/levels/2x/retina_MirrorSegDetailed.png
// module id = 693
// module chunks = 0